<script>
    import route from "../../stores/route.js";
    import chronology, { dayNumber } from "../../stores/chronology.js";
    import locality from "../../stores/locality.js";
    import localTime from "../../stores/localTime.js";
    import weather from "../../stores/weather.js";

    $: localityValue = (() => {
        if ($locality === undefined) {
            return "Loading...";
        }

        if ($locality === null) {
            return "Unknown";
        }

        return $locality;
    })();
</script>

<div class="info">
    <table cellpadding="0" cellspacing="0">
        <tr>
            <td width="40%">Day Number</td>
            <td>{dayNumber($chronology)}</td>
        </tr>
        <tr>
            <td>Locality</td>
            <td>{localityValue}</td>
        </tr>
        <tr>
            <td>Date & Time</td>
            <td>{$localTime ? $localTime.formatted : ""}</td>
        </tr>
        <tr>
            <td>Weather</td>
            <td>{$weather ? $weather.formatted : "Loading..."}</td>
        </tr>
    </table>
</div>

<style>
    table {
        width: 100%;
    }

    td {
        border-top: black 1px solid;
        border-right: black 1px solid;
        background: var(--chrome-hsl);
        background: white;
        padding: var(--chrome-depth);
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    tr:last-child td {
        border-bottom: black 1px solid;
    }

    tr td:first-child {
        border-top: var(--border-color-light) var(--chrome-depth) outset;
        border-right: var(--border-color-dark) var(--chrome-depth) outset;
        border-bottom: var(--border-color-dark) var(--chrome-depth) outset;
        border-left: var(--border-color-light) var(--chrome-depth) outset;
        background: var(--chrome-hsl);
    }
</style>
